<template>
  <div class="us">
    <banner
      img="https://zcts-web.oss-cn-shenzhen.aliyuncs.com/zc/cd730bbcd84f4f7fa4d6f1bd20bae0a8.jfif"
      :title="$t('contactUs2')"
    />
    <div class="us-section" v-loading="loading">
      <div class="us-section-content">
        <div class="map">
          <div id="container"></div>
        </div>
        <!-- 地图 -->

        <!-- 输入框 -->
        <div class="contact-us">
          <!-- 左侧：表单 -->
          <div class="form-container">
            <h2>{{ $t("contactUs") }}</h2>
            <el-form
              ref="contactForm"
              :model="form"
              :rules="rules"
              label-width="150px"
              class="contact-form"
            >
              <!-- 姓名 -->
              <el-form-item :label="$t('nickname')" prop="name">
                <el-input
                  v-model="form.name"
                  :placeholder="$t('enterYourName')"
                />
              </el-form-item>

              <!-- 电话 -->
              <el-form-item :label="$t('phone')" prop="phone">
                <el-input
                  v-model="form.phone"
                  :placeholder="$t('enterYourPhone')"
                />
              </el-form-item>

              <!-- 邮箱（选填） -->
              <el-form-item :label="$t('email')" prop="email">
                <el-input
                  v-model="form.email"
                  :placeholder="$t('enterYourEmail')"
                />
              </el-form-item>

              <!-- 公司名称 -->
              <el-form-item :label="$t('subject')" prop="theme">
                <el-input
                  v-model="form.theme"
                  :placeholder="$t('enterSubject')"
                />
              </el-form-item>

              <!-- 合作意向 -->
              <el-form-item :label="$t('cooperationIntent')" prop="cooperationIntent">
                <el-radio-group v-model="form.cooperationIntent" class="intent-group">
                  <el-radio
                    v-for="item in intentOptions"
                    :key="item.value"
                    :label="item.value"
                  >{{ item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>

              <!-- 留言 -->
              <el-form-item :label="$t('leaveMessage')" prop="leaveWord">
                <el-input
                  v-model="form.leaveWord"
                  type="textarea"
                  rows="5"
                  :placeholder="leavePlaceholder"
                />
              </el-form-item>

              <!-- 提交按钮（通过后弹出本地滑块验证，不依赖外网图片） -->
              <el-form-item>
                <el-button
                  type="primary"
                  :loading="submitting"
                  :disabled="submitting"
                  @click="submitForm"
                  style="background-color: #31814b; border: none"
                  ><span>{{ $t("send") }}</span></el-button
                >
              </el-form-item>
            </el-form>

            <contact-verify-dialog
              :visible.sync="verifyVisible"
              theme-color="#31814b"
              :title="$t('verifyDialogTitle')"
              :description="$t('verifyDialogDesc')"
              :slide-text="$t('slideVerifyText')"
              :success-text="$t('verificationSuccess')"
              :cancel-text="$t('cancel')"
              @success="onVerifySuccess"
            />
          </div>

          <!-- 右侧：联系信息 -->
          <div class="contact-info">
            <ul>
              <li>
                <i class="el-icon-location-outline"></i>
                <div>
                  <h4>{{ $t("address") }}</h4>
                  <p>{{ companyData.address }}</p>
                </div>
              </li>
              <li>
                <i class="el-icon-phone-outline"></i>
                <div>
                  <h4>{{ $t("phone") }}</h4>
                  <p>
                    {{ companyData.phone }}<br />{{ $t("mondayToFriday") }} 8:30
                    - 17:30
                  </p>
                </div>
              </li>
              <li>
                <i class="el-icon-message"></i>
                <div>
                  <h4>{{ $t("email") }}</h4>
                  <p>{{ companyData.email }}<br />{{ $t("contact") }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
import { Loader } from "@googlemaps/js-api-loader"; // 引入谷歌地图加载器
import { getMsg } from "@/api/company.js";
import { addContactPage } from "@/api/contact.js";
import ContactVerifyDialog from "@/components/ContactVerifyDialog.vue";

export default {
  components: {
    Banner,
    ContactVerifyDialog,
  },
  data() {
    return {
      loading: false,
      submitting: false,
      verifyVisible: false,
      map: null,
      // 表单数据
      form: {
        name: "",
        email: "",
        phone: "",
        theme: "",
        cooperationIntent: "",
        leaveWord: "",
      },
      rules: {
        name: [
          { required: true, message: this.$t("nameRequired"), trigger: "blur" },
          { min: 2, max: 30, message: this.$t("nameLengthBetween2And30"), trigger: "blur" },
        ],
        phone: [
          { required: true, validator: this.validatePhone, trigger: "blur" },
        ],
        email: [
          { validator: this.validateEmail, trigger: "blur" },
        ],
        theme: [
          { required: true, message: this.$t("companyRequired"), trigger: "blur" },
          { min: 2, max: 100, message: this.$t("subjectLengthLimit"), trigger: "blur" },
        ],
        cooperationIntent: [
          { required: true, message: this.$t("selectIntent"), trigger: "change" },
        ],
        leaveWord: [
          { required: true, message: this.$t("enterMessageContent"), trigger: "blur" },
          { min: 10, max: 500, message: this.$t("messageContentLengthLimit"), trigger: "blur" },
        ],
      },
      companyData: {},
    };
  },
  computed: {
    intentOptions() {
      return [
        { value: "1", label: this.$t("intentLogistics") },
        { value: "2", label: this.$t("intentTrade") },
        { value: "3", label: this.$t("intentSupplier") },
        { value: "4", label: this.$t("intentOther") },
      ];
    },
    leavePlaceholder() {
      const map = {
        1: this.$t("leaveHintLogistics"),
        2: this.$t("leaveHintTrade"),
        3: this.$t("leaveHintSupplier"),
        4: this.$t("leaveHintOther"),
      };
      return map[this.form.cooperationIntent] || this.$t("leaveHintDefault");
    },
  },
  methods: {
    validatePhone(rule, value, callback) {
      const raw = (value || "").trim();
      if (!raw) {
        callback(new Error(this.$t("phoneRequired")));
        return;
      }
      const normalized = raw.replace(/[\s-]/g, "");
      const chinaMobile = /^(?:\+?86)?1[3-9]\d{9}$/.test(normalized);
      const intlMobile = /^\+[1-9]\d{7,14}$/.test(normalized);
      if (chinaMobile || intlMobile) {
        callback();
      } else {
        callback(new Error(this.$t("invalidPhone")));
      }
    },
    validateEmail(rule, value, callback) {
      const raw = (value || "").trim();
      if (!raw) {
        callback();
        return;
      }
      const ok = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(raw);
      if (ok) {
        callback();
      } else {
        callback(new Error(this.$t("enterValidEmail")));
      }
    },
    resetFormAfterSubmit() {
      this.form = {
        name: "",
        phone: "",
        email: "",
        theme: "",
        cooperationIntent: "",
        leaveWord: "",
      };
      this.$nextTick(() => {
        this.$refs.contactForm && this.$refs.contactForm.clearValidate();
      });
    },
    doSubmitContact() {
      this.submitting = true;
      addContactPage(this.form)
        .then(() => {
          this.$message.success(this.$t("formSubmitSuccess"));
          this.resetFormAfterSubmit();
        })
        .catch(() => {
          this.$message.error(this.$t("submitFailed"));
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    onVerifySuccess() {
      this.doSubmitContact();
    },
    // 先校验表单，再弹出滑块验证
    submitForm() {
      if (this.submitting) {
        return;
      }
      this.$refs.contactForm.validate((valid) => {
        if (!valid) {
          this.$message.error(this.$t("completeFormBeforeSubmitting"));
          return false;
        }
        this.verifyVisible = true;
      });
    },
    // 初始化谷歌地图
    async initMap() {
      const loader = new Loader({
        apiKey: "AIzaSyApJhdfSVI6BycgM8C5BY_dj9oaLquIC6Y", // 替换为你的谷歌地图 API 密钥
        version: "weekly",
        language: localStorage.getItem("locale") || "zh-CN", // 根据语言设置地图语言
      });

      try {
        await loader.load();

        // 初始化地图
        const centerPoint = {
          lat: Number(this.companyData.latitude),
          lng: Number(this.companyData.longitude),
        };

        this.map = new google.maps.Map(document.getElementById("container"), {
          center: centerPoint,
          zoom: 15, // 设置缩放级别
        });

        // 添加标记
        new google.maps.Marker({
          position: centerPoint,
          map: this.map,
          title: this.$t("currentLocation"),
        });
      } catch (error) {
        console.error("谷歌地图加载失败：", error);
      }
    },
    init() {
      getMsg().then((res) => {
        this.companyData = res.data;
        //DOM初始化完成进行地图初始化
        this.initMap();
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
  
<style lang="scss" scoped>
.us {
  width: 100%;
  height: 100%;
  background: url(https://zcts-web.oss-cn-shenzhen.aliyuncs.com/img2/bg_all.jpg)
    no-repeat center;
  background-size: cover;
  &-section {
    width: 100%;

    &-content {
      width: 1425px;
      margin: 0 auto;
      background-color: #fff;
    }
  }
}
.map {
  margin: 50px 100px;
}
.el-button {
  padding-top: 15px !important;
  color: #fff !important;
  font-size: 18px !important;
  font-weight: bold !important;
}

#container {
  width: 1250px;
  height: 600px;
}
.contact-us {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px;
  //   background-color: #f9f9f9;

  .form-container {
    width: 60%;
    h2 {
      font-size: 30px;
      margin-bottom: 15px;
      margin-left: 58px;
    }

    .contact-form {
      max-width: 720px;

      .el-form-item {
        .el-input {
          width: 100%;
        }
      }

      .intent-group {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        padding-top: 8px;

        .el-radio {
          margin-right: 0;
          white-space: normal;
          line-height: 1.5;

          &.is-checked {
            ::v-deep .el-radio__label {
              color: #31814b;
            }

            ::v-deep .el-radio__inner {
              border-color: #31814b;
              background-color: #31814b;
            }
          }
        }
      }
    }
  }

  .contact-info {
    width: 35%;
    // background-color: #fff;
    padding: 20px;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        display: flex;
        align-items: flex-start;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        i {
          font-size: 42px;
          margin-right: 10px;
          color: #31814b;
        }

        h4 {
          margin: 0 0 5px;
          font-size: 30px;
          font-weight: bold;
        }

        p {
          margin: 0;
          font-size: 20px;
          line-height: 1.5;
          color: #666;
        }
      }
    }
  }
}
</style>